import type { VanityModalState } from './types';

export const mutations = {
	setVanityUrl: (state: VanityModalState, vanityUrl: string): VanityModalState => ({
		...state,
		vanityUrl,
	}),
	setViewState: (state: VanityModalState, viewState: VanityModalState['viewState']): VanityModalState => ({
		...state,
		viewState,
	}),
};
